import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import InputMaterialAmountForm from "./InputMaterialAmountForm";
import InputMaterial, { newInputMaterial } from "../../models/input-material";

interface InputMaterialAmountModalProps {
  show: boolean;
  inputMaterial?: InputMaterial;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const InputMaterialAmountModal: React.FC<InputMaterialAmountModalProps> = ({
  show,
  inputMaterial,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialInputMaterial, setInitialInputMaterial] =
    useState<InputMaterial>(inputMaterial ? inputMaterial : newInputMaterial());

  const modalTitle = inputMaterial
    ? `Agregar/disminuir Stock a materia prima: ${inputMaterial.identifier}`
    : `Agregar/disminuir Stock a materia prima`;

  const onClose = () => {
    setInitialErrors({});
    setInitialInputMaterial(newInputMaterial());
    onCancel();
  };
  useEffect(() => {
    setInitialInputMaterial(inputMaterial ? inputMaterial : newInputMaterial());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMaterial]);

  return (
    <CModal show={show} onClose={onClose} size="xl" className="modal-primary">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <h5>Las cantidades seran agregadas al inventario actual</h5>
          <p>
            Puede usar números positivos para agregar o números negativos para
            disminuir
          </p>
          <InputMaterialAmountForm
            initialInputMaterial={initialInputMaterial}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default InputMaterialAmountModal;
